import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import '../../../services/tealium/dist/es/types/shared/products.js';
import '../../../services/tealium/dist/es/events/event-properties-provider.js';
import { useDispatchTrackClickEvent } from '../../../services/tealium/dist/es/events/use-track-click-event.js';
import '../../../services/tealium/dist/es/events/use-track-error-event.js';
import { useIsApplePaySupportedForCart } from '../../../hooks/use-is-apple-pay-supported-for-cart.js';
import '../../../models/adyen/payment-type.js';
import { ExpressPaymentMethod, PaymentMethod } from '../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../models/googlePay/types.js';
import '../../../models/payment/types.js';
import '../../../models/paypal/context.js';
import { ApplePayButton } from './ApplePayButton.js';

const ApplePayExpressCheckoutButtonContainer = ({ cartId , cartHash , onClickHandler  })=>{
    const dispatchTealiumTrackEvent = useDispatchTrackClickEvent();
    const cartLink = useLink({
        route: 'cart.overview'
    });
    const expressCheckoutLink = useLink({
        route: 'express-checkout',
        params: swcHelpers.objectSpread({
            type: ExpressPaymentMethod.APPLE_PAY,
            returnPath: cartLink === null || cartLink === void 0 ? void 0 : cartLink.href,
            cartId
        }, cartHash ? {
            cartHash
        } : null)
    });
    const handleOnClick = React.useCallback(()=>{
        dispatchTealiumTrackEvent({
            data_element_id: 'Summary_ApplePayCheckout',
            data_description: 'checkout_with_applepay'
        });
        onClickHandler && onClickHandler(PaymentMethod.APPLE_PAY);
        expressCheckoutLink && expressCheckoutLink.onClick();
    }, [
        expressCheckoutLink,
        onClickHandler,
        dispatchTealiumTrackEvent
    ]);
    const { isApplePaySupportedForCart , called , loading  } = useIsApplePaySupportedForCart(cartId);
    if (!isApplePaySupportedForCart || !called || loading) {
        return null;
    }
    if (!expressCheckoutLink) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ApplePayButton, {
        onClick: handleOnClick
    });
};

export { ApplePayExpressCheckoutButtonContainer };
//# sourceMappingURL=ApplePayExpressCheckoutButtonContainer.js.map
